import Blue from "~/core";

new Blue({
	name: 'Alert',
	selector: ".alert",
	setup(alert) {
		const alerts = [...alert.querySelectorAll(".alert__message")];

		const searchModal = document.querySelector(".search-modal");
		const header = document.querySelector("header.header");

		const prev = alert.querySelector("button.alert__prev");
		const next = alert.querySelector("button.alert__next");
		const close = alert.querySelector("button.alert__close");
		const currentNumber = alert.querySelector("span.alert__current");
		const totalNumber = alert.querySelector("span.alert__total");
		const controller = alert.querySelector(".alert__controls");

		if (alerts.length > 0 && sessionStorage.getItem('alert') !== 'hidden') {
			alert.classList.add("alert--visible");
		}
		else {
			alert.classList.remove("alert--visible");
		}

		if (alerts.length > 1) {
			controller.classList.add("alert__controls--visible");
			totalNumber.innerHTML = alerts.length;
		}

		const alertNavigation = (direction) => {
			let index;
			const start = alert.offsetHeight;
			alerts.forEach((alert, i) => {
				if (alert.matches(".center")) index = i;
			});

			if (direction === 1) {
				alerts.forEach((alert) => {
					alert.classList.remove("pos-left")
					if (!alert.matches(".center")) {
						alert.classList.add("pos-right")
					}
				})
				alerts[index].classList.add("pos-left");
			} else {
				alerts.forEach((alert) => {
					alert.classList.remove("pos-right")
					if (!alert.matches(".center")) {
						alert.classList.add("pos-left")
					}
				})
				alerts[index].classList.add("pos-right");
			}

			alerts[index].classList.remove("center");

			if (index === alerts.length - 1 && direction === 1) {
				index = -1;
			} else if (index === 0 && direction === -1) {
				index = alerts.length;
			}

			alerts[index + direction].classList.add("center");
			alerts[index + direction].classList.remove("pos-right");
			alerts[index + direction].classList.remove("pos-left");

			const end = alert.offsetHeight;
			alert.animate([
				{height: `${start}px`},
				{height: `${end}px`}
			], {
				duration: 350,
				easing: 'ease'
			})

			currentNumber.innerHTML = (index + 1) + direction;
		}

		const closeAlert = () => {
			sessionStorage.setItem('alert', 'hidden');
			alert.classList.remove("alert--visible");
		}

		this.$addEvents(next, "click", () => {alertNavigation(1)});
		this.$addEvents(prev, "click", () => {alertNavigation(-1)});
		this.$addEvents(close, "click", () => {closeAlert()});
	}
});
